<template>
  <div>
    <a href="#" @click.prevent="visible = !visible" v-if="versions.length">{{
      visible ? "Hide versions" : "Show versions"
    }}</a>
    <b-collapse v-model="visible" id="versions" class="mb-2">
      <b-card>
        <b-row>
          <b-col><strong>Version name</strong></b-col>
          <b-col><strong>Created</strong></b-col>
          <b-col><strong>Last updated</strong></b-col>
          <b-col></b-col>
        </b-row>
        <b-row v-for="version in versions" :key="version.id">
          <b-col>
            <router-link
              :to="{
                name: 'EditVersion',
                params: { familyId, id: version.id }
              }"
            >
              {{ version.version_name }}
            </router-link>
            <span v-if="version.id === versionId">(This version)</span>
          </b-col>
          <b-col>{{ formatDate(version.created_on) }}</b-col>
          <b-col>{{ formatDate(version.updated_on) }}</b-col>
          <b-col>{{ version.published ? "" : "Private" }}</b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "VersionList",
  mixins: [dateFormat],
  props: {
    familyId: {
      type: String
    },
    versions: {
      type: Array
    },
    versionId: {
      type: String
    }
  },
  data() {
    return {
      visible: false
    };
  }
};
</script>
